<template>
    <div class="story-form-post-creator hide-scrollbar">
        <section class="publish-date">
            <label>{{ $t('dash.post-creator.form.publish-date') }}</label>
            <div class="content-section">
                <SelectComponent
                    :changeValueSelect="changeSelectPublishDate"
                    :data="{now: $t('dash.post-creator.form.now'), flanified: $t('dash.button.schedule')}"
                    :valueSelect="!formData.planifiedDate.date ? 'now' : 'flanified'"
                    :positionAuto="false" :positionX="'left'">
                </SelectComponent>
                <template v-if="formData.planifiedDate.date !== false && formData.planifiedDate.hours !== false">
                    <div class="input-date">
                        <p>{{ formatInputDatePicker }}</p>
                        <i class="fa-regular fa-calendar"></i>
                        <input type="date"
                            v-model="formData.planifiedDate.date"
                            :disabled="formData.planifiedDate.date ? false : true"
                            @click="(e)=>e.target.showPicker()"
                            :min="new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')"
                        >
                    </div>
                    <div class="input-hours">
                        <VueTimepicker v-model="formData.planifiedDate.hours" manual-input @close="checkValidHours()"/>
                        <i class="fa-regular fa-clock"></i>
                    </div>
                </template>
            </div>
        </section>

        <section class="content-media">
            <label>{{ $t('dash.post-creator.story.background') }}</label>
            <div class="container-medias">
                <div class="btn-color" @click="()=>{colorPickerShow = true; showPipette = true}" :style="{backgroundColor: story.background.color}">
                    <div class="picker-color" v-if="colorPickerShow" @mouseleave="()=>{colorPickerShow = false; this.$emit('saveFormData')}" @mousedown="showPipette = false">
                        <div class="icon-pipette" v-if="eyeDropperIsAccess && showPipette" @mousedown.stop @click.stop="startEyeDropper"></div>
                        <chrome-picker :value="{hex: story.background.color}" @input="updateFromPicker"/>
                    </div>
                </div>

                <input
                    name="file"
                    type="file"
                    id="fileFacebookStory"
                    ref="inputMediaStory"
                    @change="uploadBackgroundFile"
                    :multiple="false"
                    :accept="'.jpg, .jpeg, .png, .webp, .mp4, .mov, .avi, .wmv, .flv, .mkv'"
                    hidden
                >
                <DropFile :targetInput="$refs.inputMediaStory"/>

                <template v-if="backgroundFileId && files[backgroundFileId]">
                    <Tooltip
                        :active="!files[backgroundFileId].isUpload && !files[backgroundFileId].uploadProgress"
                        :text="$t('dash.post-creator.media.upload-failed')"
                        position="bottom"
                    >
                        <div class="media-container picture" v-if="files[backgroundFileId].info.type.startsWith('image/')">
                            <i v-if="!files[backgroundFileId].isUpload && !files[backgroundFileId].uploadProgress" class="fa-solid fa-rotate-right" @click.stop="retryBackgroundFile"></i>
                            <i class="fa-solid fa-circle-xmark" @click.stop="removeBackgroundFile"></i>
                            <div class="media picture">
                                <img draggable="false" :src="files[backgroundFileId].url" alt="" class="source">
                            </div>
                            <div v-if="!files[backgroundFileId].isUpload && files[backgroundFileId].uploadProgress" class="containerProgressBar">
                                <div class="progressBar">
                                    <div class="bar" :style="{width: `${parseInt(files[backgroundFileId].percentUpload)}%`}"></div>
                                </div>
                            </div>
                        </div>

                        <div class="media-container video" v-else-if="files[backgroundFileId].info.type.startsWith('video/')">
                            <i class="fa-solid fa-circle-xmark" @click.stop="removeBackgroundFile"></i>
                            <div class="media video">
                                <video muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true" :src="files[backgroundFileId].url" :type="files[backgroundFileId].info.type"></video>
                            </div>
                        </div>
                    </Tooltip>
                </template>

                <div class="btn-add-media" v-else @click="$refs.inputMediaStory.click()">
                    <i class="fa-solid fa-photo-film"></i>
                </div>
            </div>
        </section>

        <section class="content-stickers">
            <label>{{ $t('dash.post-creator.story.stickers') }}</label>
            <div class="container-stickers">
                <draggable class="list-stickers hide-scrollbar" ref="listStickers" v-model="stickersSortByZIndex" v-bind="dragOptions" @start="drag=true" @end="onDragStickerEnd" :filter="'.lockdrag'">
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        <template v-for="sticker in stickersSortByZIndex">
                            <div v-if="sticker.id == 'btnAdd'" @click="openMenuStickers" class="btn-add-sticker lockdrag" :class="{'no-drag' : drag}" :key="'btnAdd'">
                                <svg width="auto" height="auto" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6667 0H31.3333C38.3289 0 44 5.67106 44 12.6667V25.1242C44 26.5387 43.4381 27.8952 42.4379 28.8954L28.8954 42.4379C27.8952 43.4381 26.5387 44 25.1242 44H12.6667C5.67106 44 0 38.3289 0 31.3333V12.6667C0 5.67106 5.67106 0 12.6667 0ZM12.6667 4C7.8802 4 4 7.8802 4 12.6667V31.3333C4 36.1198 7.8802 40 12.6667 40H25.3333L40 25.3333V12.6667C40 7.8802 36.1198 4 31.3333 4H12.6667Z" fill="#F1EDF5"/>
                                    <path d="M35.334 23.334H43.334L41.334 27.334H35.334C30.9157 27.334 27.334 30.9157 27.334 35.334V40.6673L23.334 41.334V35.334C23.334 28.7066 28.7066 23.334 35.334 23.334Z" fill="#F1EDF5"/>
                                    <path d="M16.6673 18.0007C16.6673 19.4734 15.4734 20.6673 14.0007 20.6673C12.5279 20.6673 11.334 19.4734 11.334 18.0007C11.334 16.5279 12.5279 15.334 14.0007 15.334C15.4734 15.334 16.6673 16.5279 16.6673 18.0007Z" fill="#F1EDF5"/>
                                    <path d="M32.6673 18.0007C32.6673 19.4734 31.4734 20.6673 30.0007 20.6673C28.5279 20.6673 27.334 19.4734 27.334 18.0007C27.334 16.5279 28.5279 15.334 30.0007 15.334C31.4734 15.334 32.6673 16.5279 32.6673 18.0007Z" fill="#F1EDF5"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9633 26.2096C13.7676 25.4526 15.0334 25.4909 15.7904 26.2953C17.9806 28.6224 20.4661 29.1591 22.4662 29.1247C23.4806 29.1072 24.3615 28.9402 24.986 28.7775C25.2962 28.6967 25.5372 28.6185 25.6927 28.5638C25.7703 28.5365 25.8261 28.5152 25.8581 28.5027C25.874 28.4965 25.884 28.4924 25.8876 28.4909L25.8852 28.492L25.8826 28.4931M25.8881 28.4907C26.9014 28.062 28.0717 28.5325 28.5056 29.5448C28.9407 30.5601 28.4704 31.7359 27.4552 32.171L26.675 30.3507C27.4552 32.171 27.4543 32.1714 27.4534 32.1718L27.4514 32.1726L27.4469 32.1745L27.4361 32.1791L27.4065 32.1913C27.3834 32.2008 27.3534 32.2129 27.3168 32.2273C27.2435 32.2559 27.1437 32.2936 27.0195 32.3373C26.7715 32.4245 26.4239 32.5364 25.9945 32.6483C25.1398 32.871 23.9374 33.0999 22.5351 33.1241C19.7019 33.1729 16.0207 32.3763 12.8776 29.0368C12.1206 28.2324 12.1589 26.9667 12.9633 26.2096M25.8881 28.4907C25.888 28.4908 25.8878 28.4909 25.8876 28.4909L25.8884 28.4906L25.8892 28.4903C25.889 28.4904 25.8887 28.4905 25.8881 28.4907Z" fill="#F1EDF5"/>
                                </svg>
                            </div>
                            <div v-else class="stricker" @click="()=>clickSticker(sticker.id)" :key="sticker.id">
                                <i class="fa-solid fa-circle-xmark" @click.stop="deleteSticker(sticker.id)"></i>
                                <div class="sticker-view">
                                    <Tooltip
                                        v-if="sticker.type === 'music'"
                                        :text="sticker.data.music && `${sticker.data.music.track.display_artist} - ${sticker.data.music.track.title}`"
                                        position="bottom"
                                        classCustom="music"
                                    >
                                        <div class="disk">
                                            <img :src="sticker.data.music.track.cover_artwork_thumbnail_uri">
                                        </div>
                                    </Tooltip>

                                    <stickerWrapperFacebook v-else :sticker="{...sticker, isEditing: false}" :pageSelected="pageSelected" />
                                </div>
                                <p class="sticker-type">{{ sticker.type }}</p>
                            </div>
                        </template>
                    </transition-group>
                </draggable>
            </div>
        </section>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import SelectComponent from '@/components/dash/utils/select.vue'
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import DropFile from '@/components/dash/DropFile.vue'
import { getValidPlanifiedDateTime } from '../../utils.js'
import { Chrome } from 'vue-color'
import draggable from 'vuedraggable'
import stickerWrapperFacebook from './storyMaker/stiker/stickerWrapperFacebook.vue'

export default {
    components: {
        SelectComponent,
        Tooltip,
        VueTimepicker,
        DropFile,
        'chrome-picker': Chrome,
        draggable,
        stickerWrapperFacebook,
    },

    props: {
        formData: Object,
        files: Object,
        pageSelected: Object,
        idStorySelected: {
            type: String,
            default: '0'
        },
    },

    data() {
        return {
            colorPickerShow: false,
            showPipette: false,
            eyeDropperIsAccess: false,
            stickersSortByZIndex: [],
            drag: false,
        }
    },


    mounted() {
        this.eyeDropperIsAccess = window.EyeDropper ? true : false
        this.sortStickers()
    },

    methods: {
        updateFromPicker(value) {
            this.$set(this.story.background, 'color', value.hex)
        },

        startEyeDropper() {
            if (!window.EyeDropper) return
            this.colorPickerShow = false
            this.$emit('saveFormData')
            const eyeDropper = new EyeDropper();

            eyeDropper.open().then((result) => {
                this.$set(this.story.background, 'color', result.sRGBHex)
                this.$emit('saveFormData')
            }).catch((e) => {});
        },

        changeSelectPublishDate(value) {
            if (!this.date && value == "flanified") {
                let date = new Date((new Date).getTime() + 3600000)
                this.$set(this.formData.planifiedDate, 'date', date.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-'));
                this.$set(this.formData.planifiedDate, 'hours', date.toLocaleString('fr-FR').split(' ')[1].split(':').slice(0,2).join(':'));
            } else if (value == "now") {
                this.$set(this.formData.planifiedDate, 'date', false)
                this.$set(this.formData.planifiedDate, 'hours', false)
            }
            this.$emit('saveFormData')
        },

        calculTimeStampPlanifiedDate() {
            let date = new Date(this.formData.planifiedDate.date)
            if (this.formData.planifiedDate.hours.includes(":")) {
                let [hours, minutes] = this.formData.planifiedDate.hours.split(':').map(value => isNaN(value) ? 0 : parseInt(value))
                date.setMinutes(minutes)
                date.setHours(hours)
            }
            this.$set(this.formData.planifiedDate, 'timestamp', date.getTime());
            this.$emit('saveFormData')
        },

        checkValidHours() {
            if (!this.formData.planifiedDate.date) return

            const { date, hours } = getValidPlanifiedDateTime(this.formData.planifiedDate.date, this.formData.planifiedDate.hours)

            this.$set(this.formData.planifiedDate, 'hours', hours)
            this.$set(this.formData.planifiedDate, 'date', date)
            this.calculTimeStampPlanifiedDate()
        },

        uploadBackgroundFile(event) {
            const file = event.target.files[0];
            const id = Math.random().toString(36).substr(2, 9)
            if (!file) return

            this.$emit('addFile', null, file, true, id, () => {
                if (this.files[id]) {
                    this.$set(this.story.background, 'file', { id })

                    if (this.files[id].info.aspectRatio) {
                        this.$set(
                            this.story.background,
                            'size',
                            this.files[id].info.aspectRatio > 0.5625 ? 'containX' : 'containY'
                        )
                    }
                    if (this.files[id].info.averageColor) {
                        this.$set(
                            this.story.background,
                            'color',
                            this.files[id].info.averageColor
                        )
                    }

                    this.$emit('saveFormData')
                }
            })
        },

        removeBackgroundFile() {
            const removedFileId = this.backgroundFileId
            this.$set(this.story.background, 'file', null)
            this.$emit('saveFormData')
            this.$emit('discardFailedFile', removedFileId)
        },

        retryBackgroundFile() {
            this.$emit('retryUploadFile', this.backgroundFileId)
        },

        sortStickers() {
            this.stickersSortByZIndex = [{id:'btnAdd'}, ...Object.values(this.stickers).sort((a,b) => b.zIndex - a.zIndex)]
        },

        onDragStickerEnd() {
            this.drag = false
            this.$set(
                this.story,
                'stickers',
                this.stickersSortByZIndex
                    .filter(sticker => sticker.id !== 'btnAdd')
                    .reduce((acc, sticker, index) => ({
                        ...acc,
                        [sticker.id]: {
                            ...sticker,
                            zIndex: this.stickersSortByZIndex.length - index,
                        }
                    }), {})
            )
            EventBus.$emit("storyMaker-setOverlay", false)
            this.$emit('saveFormData')
        },

        deleteSticker(id) {
            this.$delete(this.story.stickers, id)
            this.$emit('saveFormData')
        },

        clickSticker(id) {
            const sticker = this.story.stickers[id]
            if (!sticker) return
            if (sticker.type === 'link') {
                EventBus.$emit('storyMaker-setOverlay', 'stickers-linkMenu', { id: sticker.id, ...sticker.data })
                return
            }
            this.$set(this.story.stickers, id, {
                ...sticker,
                isEditing: true,
            })
            this.$emit('saveFormData')
        },

        openMenuStickers() {
            EventBus.$emit("storyMaker-setOverlay", 'stickers')
        },
    },

    computed: {
        story() {
            return this.formData.storification[this.idStorySelected] || this.formData.storification['0']
        },
        stickers() {
            return this.story.stickers || {}
        },
        dragOptions() {
            return {
                animation: 200,
                group: "description-facebook",
                disabled: false,
                ghostClass: "ghost"
            };
        },

        formatInputDatePicker() {
            if (this.formData.planifiedDate.date == false) return '';
            let dateNow = new Date()
            let dateFuture = new Date(this.formData.planifiedDate.date)

            if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                if (Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24)) < 7) {
                    if (dateFuture.getDay() === dateNow.getDay()) return this.$t('dash.post-creator.render.today')
                    if (dateFuture.getDay() === dateNow.getDay()+1) return this.$t('dash.post-creator.render.tomorrow')
                    return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long' });
                }
                if (dateFuture.getMonth() === dateNow.getMonth()) return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric'});
                return dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric', month: 'numeric' });
            }
            return dateFuture.toLocaleDateString(localStorage.language || undefined, { day: 'numeric', month: 'numeric', year: 'numeric' });
        },

        backgroundFileId() {
            return this.story.background.file ? this.story.background.file.id : null
        },
    },

    watch: {
        ["formData.planifiedDate.date"]: {
            immediate: true,
            handler(newValue) {
                if (!newValue || !newValue.length) {
                    this.formData.planifiedDate.hours = false
                    this.formData.planifiedDate.timestamp = false
                } else {
                    this.checkValidHours()
                }
            }
        },

        stickers: {
            handler() {
                this.sortStickers()
            },
            deep: true,
            immediate: true
        },

        idStorySelected: {
            immediate: true,
            handler() {
                if (!this.story) return
                if (!this.story.stickers) this.$set(this.story, 'stickers', {})
                this.sortStickers()
            }
        },
    },
}
</script>
